export default "__VITE_PUBLIC_ASSET__5f207ec2__"